import type { ExtensionType } from '@blocksuite/store';

import { EmbedVideoBlockHtmlAdapterExtension } from './html.js';
import { EmbedVideoMarkdownAdapterExtension } from './markdown.js';
import { EmbedVideoBlockNotionHtmlAdapterExtension } from './notion-html.js';
import { EmbedVideoBlockPlainTextAdapterExtension } from './plain-text.js';

export const EmbedVideoBlockAdapterExtensions: ExtensionType[] = [
  EmbedVideoBlockHtmlAdapterExtension,
  EmbedVideoMarkdownAdapterExtension,
  EmbedVideoBlockPlainTextAdapterExtension,
  EmbedVideoBlockNotionHtmlAdapterExtension,
];
